import { render, staticRenderFns } from "./ZalogaMaterial.vue?vue&type=template&id=40e996d2&"
import script from "./ZalogaMaterial.vue?vue&type=script&lang=js&"
export * from "./ZalogaMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports